<template>
    <!-- <ServiceDetailSection /> -->
    <ServiceDetailsSection />
</template>

<script>
// import ServiceDetailSection from '@/components/service_detail/ServiceDetailSection.vue';
import ServiceDetailsSection from '@/components/service_detail/ServiceDetailsSection.vue';

export default {
    name: 'ServiceDetailView',
    components: {
        // ServiceDetailSection,
        ServiceDetailsSection,
    }
}
</script>